import clsx from 'clsx';
import { AmpNavigation, Config } from '@amplify/amp-navigation';
import { KeycloakInstance } from 'keycloak-js';
import { useLocation } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';

import { ReadOnlyBanner } from 'shared/ui/read-only-banner';
import { AuthService } from 'shared/lib/keycloak';
import { Asset } from 'shared/api/retail';

import styles from './styles.module.scss';

const Navigation = ({ userAssets }: { userAssets?: Asset[] }) => {
  const { pathname } = useLocation();
  const [tokenUpdated, setTokenUpdated] = useState(false);
  const [isNavVisible, setIsNavVisible] = useState(true);
  const showReadOnlyBanner = AuthService.isReadOnly();

  useEffect(() => {
    const handleTokenRefresh = () => {
      // Toggle the state variable to trigger a re-render
      setTokenUpdated((prev) => !prev);
    };

    window.addEventListener('tokenRefreshed', handleTokenRefresh);

    return () => {
      window.removeEventListener('tokenRefreshed', handleTokenRefresh);
    };
  }, []);

  const navConfig = useMemo(
    (): Config => ({
      _keycloak: {
        ...(AuthService.getKC() ?? ({} as KeycloakInstance)),
        userInfo: AuthService.getParsedToken(),
      },
      adultsView: true,
      appName: 'educator-home',
      assets: userAssets?.length ? userAssets : [],
      enableSalesforceChatSessionCleaning: true,
    }),
    // eslint-disable-next-line
    [userAssets, tokenUpdated],
  );

  if (pathname.includes('avatar')) {
    return null;
  }

  const getNavClassName = () => {
    const navigationClasses = {
      [styles.navigation]: true,
      [styles['read-only']]: showReadOnlyBanner,
    };
    return clsx(navigationClasses);
  };

  return (
    <nav className={getNavClassName()}>
      <AmpNavigation
        config={navConfig}
        onNavVisibilityChange={(isNavHidden) => {
          if (isNavHidden === isNavVisible) {
            setIsNavVisible(!isNavHidden);
          }
        }}
      />
      {showReadOnlyBanner && <ReadOnlyBanner isHidden={!isNavVisible} />}
    </nav>
  );
};

export default Navigation;
